import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '../../../infrastructure/useBookingDetailsStore'
import { hasParticipantEditExternalFields } from '../../selectors'

export function ParticipantEditExternalRequestBanner() {
  const { formatMessage } = useIntl()
  const { participantEditExternalRequestOpened } = useBookingDetailsActions()
  const hasExternalFields = useBookingDetailsStore(hasParticipantEditExternalFields)
  const isSent = useBookingDetailsStore(state => state.participantEdit.externalRequest.isSent)

  if (!hasExternalFields) {
    return null
  }

  if (isSent) {
    return (
      <Banner hasIcon color="informative" size="M">
        <Banner.TextsWrapper>
          <Banner.Text>{formatMessage({ id: 'booking_details_participant_edit_external_request_sent_title' })}</Banner.Text>
          <Banner.SupportingText>
            {formatMessage({ id: 'booking_details_participant_edit_external_request_sent_message' })}
          </Banner.SupportingText>
        </Banner.TextsWrapper>
      </Banner>
    )
  }

  return (
    <Banner hasIcon color="warning" size="M">
      <Banner.ContentWrapper actionsPosition="bottom">
        <Banner.TextsWrapper>
          <Banner.Text>{formatMessage({ id: 'booking_details_participant_edit_external_request_warning_title' })}</Banner.Text>
          <Banner.SupportingText>
            {formatMessage({ id: 'booking_details_participant_edit_external_request_warning' })}
          </Banner.SupportingText>
        </Banner.TextsWrapper>
        <Banner.ActionsWrapper actionsPosition="bottom">
          <Button variant="secondary" size="S" onClick={participantEditExternalRequestOpened}>
            {formatMessage({ id: 'booking_details_participant_edit_external_request_link' })}
          </Button>
        </Banner.ActionsWrapper>
      </Banner.ContentWrapper>
    </Banner>
  )
}
